import { Icon } from '@flintmint/web-shared/components/icon';

import { stripeCustomerUrl } from './billing-display';
import styles from './stripe-customer-link.module.scss';

export const StripeCustomerLink = ({ customerId, label }: { customerId: string; label: string }) => (
  <a className={styles.link} href={stripeCustomerUrl(customerId)} target="_blank" rel="noreferrer">
    {label}
    <Icon type="link-square-02" size={12} />
  </a>
);
